import React from 'react';
import { Button, notification } from 'antd';
import { Auth } from 'aws-amplify';

const openNotification = delay => {
  setTimeout(() => {
    return new Promise(() => {
      const key = `open${Date.now()}`;
      const btn = (
        <Button
          type="primary"
          size="small"
          onClick={async () => {
            await Auth.signOut();
            notification.close(key);
          }}
        >
          Sign In
        </Button>
      );
      notification.open({
        message: 'Session Expire',
        description:
          'Your one hour session has expired. PLease Sign In in again to continue using the Sysco Supplier Suite application',
        btn,
        key
      });
    });
  }, delay);
};

const initiateSessionExpireNotificationTrigger = async () => {
  const session = await Auth.currentSession();
  const delay = session.getAccessToken().getExpiration() * 1000 - Date.now();
  openNotification(delay);
};

export default initiateSessionExpireNotificationTrigger;
